module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAXCAMAAAC/B6aqAAAAQlBMVEUAAADBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcGcYqSSAAAAFXRSTlMA9VA/6Y9k38N7MSQZCdKzoXYRhl596fjQAAAArklEQVQoz42T2xKDIAxEQUUuIiqa///VhsoUp4voPjjEHEmyGQVqH3bxQpaI7DM2UtL4hHV0qmtjvSSSR3r0Lcx9iZN299g0pIq5+jDdYV5z+vhNo30di4GTWw42PodYw2bDqeKw4sjMFWzhxCqKVo4X5PD19cO/MtiIwqWG2BqsZYPX11WjrWh8WaprLBLORXBHuRtVeoJes3BGk2dv/whGSPASpIiksBIwBKX9AExIDSNBjjUxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/arrow-up.png
// module id = 161
// module chunks = 0